<template>
  <b-row>
    <b-col cols="12">
      <ComplaintIndex :routeName="$route.name" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import ComplaintIndex from "./ComplaintIndex.vue";

export default {
  components: {
    BRow,
    BCol,
    ComplaintIndex,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
